import React, { Component } from "react";
import {Input} from "antd";
import { injectIntl } from "react-intl";
import AcknowledgementLayout from "../../../../Containers/common/acknowledgement";
import UploadAttachments from "../../common/uploadAttachments";
import CloseIcon from "../../../../Assets/images/close.svg";
import {SecondaryButton, TertiaryButton} from "../../../Common/button";
import messages from "./messages";
import {path} from "../../../../constant";
const { TextArea } = Input;


class SuspendBatch extends Component {
  constructor(props) {
    super(props);
      this.state = {
	  loading:false,
	  showUI: false,
	  reasonDocument:""
    };
  }



    // componentDidUpdate(prevProps){
    // 	const {show:prevShow} = prevProps;
    // 	const {show} = this.props;
    // 	if(show!=prevShow && show == true){
    // 	    this.setState({reasonDocument:""});
    // 	}
    // };
    

    suspendBatchConfirmed = () => {
	this.setState({showUI: true});
	    
    }

    suspendBatch = async() => {
	this.setState({loading:true});
	const {reasonDocument, reason} = this.state;
	const {data, suspendBatch, close, getProductProfile} = this.props;
	const {batchNo, onSuccess, statusMsg, productId} = data;
	let postData={};
	postData.productId = productId;
	postData.batchNo = batchNo;
	postData.status = statusMsg;
	postData.reason = reason;
	postData.productBatchStatusUpdate = {};
	postData["productBatchStatusUpdate"]["file_path"] = reasonDocument[0].file_path;
	postData["productBatchStatusUpdate"]["originalname"] = reasonDocument[0].originalname;
	
	const response = await suspendBatch(postData);
	const {status} = response;
	this.setState({loading:false});
	if(status){
	    getProductProfile(productId);
	    this.setState({reasonDocument:"", showUI:false});
	    onSuccess();
	    close();
	}
	
    };

    uploadHandler = (data) => {
	this.setState({reasonDocument:data});
    }

    deleteUpload = () => {
	this.setState({reasonDocument:""});
    }

    
    formatMessage = data => this.props.intl.formatMessage(data);
    
   
    showConfirmationUI = () => {
	const {close, data:{batchMessage=""}} = this.props;
	const {formatMessage} = this;
	const {loading} = this.state;
	return (
		<div>
		<div className="flex justify-content-end  mt30 mr40 ml40 clickable" onClick={close}>
		<img src={CloseIcon} alt="close modal"/>
		</div>

	    <div className="flex justify-content-center align-items-center mt40 medium fontsize28">
		{batchMessage}
	    </div>
	    
	    
		<div className="flex justify-content-center align-items-center mt30">
		<TertiaryButton
	    text={formatMessage(messages.no)}
            width="wpx120"
	    handleOnClick={close}
		/>
		<SecondaryButton
	    text={formatMessage(messages.yes)}
            width="wpx120"
	    marginLeft="ml20"
	    marginRight="mr20"
	    handleOnClick={this.suspendBatchConfirmed}
	    loading={loading}
		/>
		</div>
		</div>
	);
    }


    onChangeReason = (e) => {
	this.setState({reason:e.target.value});
    }


    closeUploadUI = () => {
	const {close} = this.props;
	this.setState({showUI: false}, ()=>{close();});
    };
    

    showUploadUI = () => {
	const {formatMessage, uploadHandler, deleteUpload, onChangeReason, closeUploadUI} = this;
	const {loading, reasonDocument} = this.state;
	return (
		<div>
		<div className="flex justify-content-end  mt30 mr40 ml40 clickable" onClick={closeUploadUI}>
		<img src={CloseIcon} alt="close modal"/>
		</div>

	    <div className="flex justify-content-start align-items-center mt10 medium fs16 mandatory w75 mlauto">
		{formatMessage(messages.reason)}
	    </div>

		<div className="flex justify-content-center align-items-center mt10 w50 mlauto mrauto">
		<TextArea rows={4} onChange={onChangeReason} maxLength={100}/>
		</div>

	    <div className="flex justify-content-center">
		<UploadAttachments fieldType={"reasonDocument"} placeHolder={formatMessage(messages.reasonDoc)} width={"w60"}  uploadHandler={uploadHandler} deleteUpload={deleteUpload} type={"async"}/>
		</div>
	    
		<div className="flex justify-content-center align-items-center mt30">
		<SecondaryButton
	    text={formatMessage(messages.update)}
            width="wpx120"
	    marginLeft="ml20"
	    marginRight="mr20"
	    handleOnClick={this.suspendBatch}
	    disabled={!reasonDocument}
	    loading={loading}
		/>
		</div>
		</div>
	);
    };
    

    render() {
	const {show} = this.props;
	if(!show){
	    return null;
	}

	const {showUI} = this.state;

    return (
	    <AcknowledgementLayout>
	    {showUI ? <div>{this.showUploadUI()}</div>  : <div>{this.showConfirmationUI()}</div>}
	    </AcknowledgementLayout>
    );
  }
}

export default injectIntl(SuspendBatch);
